import { render, staticRenderFns } from "./h5.vue?vue&type=template&id=05b3e7c7&scoped=true"
import script from "./h5.vue?vue&type=script&lang=js"
export * from "./h5.vue?vue&type=script&lang=js"
import style0 from "./h5.vue?vue&type=style&index=0&id=05b3e7c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b3e7c7",
  null
  
)

export default component.exports